import {
  FETCH_ALL_PROVIDERS,
  FETCH_ALL_PROVIDERS_FAILURE,
  FETCH_ALL_PROVIDERS_SUCCESS,
  FETCH_ACTIVE_PROVIDERS,
  FETCH_ACTIVE_PROVIDERS_SUCCESS,
  FETCH_ACTIVE_PROVIDERS_FAILURE,
  TOGGLE_PROVIDER_ACTIVATION,
  TOGGLE_PROVIDER_ACTIVATION_FAILURE,
  TOGGLE_PROVIDER_ACTIVATION_SUCCESS
} from '../constant/actionType';
import { getAllProviders, toggleProviderActivation } from '../services/napi';

export function getProjectProvidersAction() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    dispatch({ type: FETCH_ACTIVE_PROVIDERS });
    try {
      const response = await getAllProviders(projectId);

      const activeProviders = response.data.providers
        .filter((item) => item.isActive === true)
        .map((item) => item.name);

      dispatch({
        data: activeProviders,
        type: FETCH_ACTIVE_PROVIDERS_SUCCESS
      });
    } catch (error) {
      dispatch({ error, type: FETCH_ACTIVE_PROVIDERS_FAILURE });
    }
  };
}

export function getAllProvidersAction() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    dispatch({ type: FETCH_ALL_PROVIDERS });

    try {
      const response = await getAllProviders(projectId);

      dispatch({
        data: response.data.providers,
        type: FETCH_ALL_PROVIDERS_SUCCESS
      });
    } catch (error) {
      dispatch({ error, type: FETCH_ALL_PROVIDERS_FAILURE });
    }
  };
}

export function toggleProviderActivationAction(project, provider) {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_PROVIDER_ACTIVATION });
    try {
      await toggleProviderActivation(project, provider);
      dispatch({
        type: TOGGLE_PROVIDER_ACTIVATION_SUCCESS
      });
      dispatch(getAllProvidersAction());
      dispatch(getProjectProvidersAction());
    } catch (error) {
      dispatch({
        error,
        type: TOGGLE_PROVIDER_ACTIVATION_FAILURE
      });
    }
  };
}
